"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var axiosModule = require("axios");
var Model = (function () {
    function Model(dataStore) {
        this.dataStore = dataStore;
        this.axios = axiosModule.create();
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.scrollDispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
    }
    Model.prototype.updateValue = function (name, value) {
        this.json_data[name] = value;
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        var results = [];
        for (var key in this.validateFunctions) {
            var f = this.validateFunctions[key];
            if (!f) {
                continue;
            }
            var r = f();
            results.push(r);
        }
        if (results.includes(false)) {
            return false;
        }
        return true;
    };
    Model.prototype.loadJsonData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = {
                            method: "get",
                            url: "/api/json_data",
                            responseType: "json",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            }
                        };
                        return [4, this.axios(request)];
                    case 1:
                        r = _a.sent();
                        console.log(r);
                        this.json_data = r.data;
                        this.dispatcher.dispatch();
                        return [2];
                }
            });
        });
    };
    Model.prototype.fileUpload = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, request, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append("autobiography", file);
                        request = {
                            method: "post",
                            url: process.env.BASE_DOMAIN + "/upload",
                            responseType: "json",
                            data: formData,
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        };
                        return [4, this.axios(request)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2, data];
                }
            });
        });
    };
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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